module.exports = __webpack_public_path__ + "img/tooltip-image.640de320.svg";